import InputWrapper, { filterInputWrapperProps } from "../InputWrapper/wrapper";
import { ensuredForwardRef } from "../../../utils";

import type { MutableRefObject } from "react";
import type { TextAreaProps } from "./types";

const TextArea = ensuredForwardRef<HTMLTextAreaElement, TextAreaProps>(
  (props: TextAreaProps, inputRef) => {
    const { wrapperClassName, id, placeholder } = props;
    const wrappedProps = filterInputWrapperProps(props);
    const InputWrapperProps = wrappedProps?.[0];

    return (
      <InputWrapper
        inputRef={inputRef as MutableRefObject<HTMLTextAreaElement>}
        {...InputWrapperProps}
        id={id}
        className={wrapperClassName}
        hasValue={!!props.value}
      >
        <textarea
          {...props}
          style={{
            resize: "vertical"
          }}
          ref={inputRef}
          aria-label={InputWrapperProps.label}
          placeholder={placeholder}
        />
      </InputWrapper>
    );
  }
);

TextArea.displayName = "TextArea";

export default TextArea;
